import { Alert as MuiAlert, styled } from '@mui/material';

export const StyledAlert = styled(MuiAlert)`
  align-items: center;
  width: 100%;
  word-break: break-all;
  overflow-wrap: break-word;
  white-space: normal;
`;
